// extracted by mini-css-extract-plugin
export var blockedMessage = "_ax-3";
export var blockedOverlay = "_ax-1";
export var fadeIn = "_ax-2";
export var hereLink = "_ax-0";
export var slideUp = "_ax-4";